import image from './image';

export default {
  install(Vue) {
    Vue.filter('resize', image);
  }
}
